import { MediaType } from '@kaltura-ott/tvpil';

export const getNormalizeMediaType = (mediaTypeParam: string) => {
  const normalizeMediaType = (mediaTypeParam.charAt(0).toUpperCase() + mediaTypeParam.slice(1)) as MediaType;

  return MediaType[normalizeMediaType] || MediaType.Program;
};
